import { observable, action } from "mobx";
import agent from "../agent";
import profileStore from "./profileStore";
import templateStore from "./templateStore";
import reportStore from "./reportStore";

import moment from "moment";
import { SuperLedgerStatus } from "../types/enum";
const SHOW_PRODUCTION_CREW = process.env.REACT_APP_SHOW_PRODUCTION_CREW === "true";

class SuperLedgerStore {
    @observable incomingLedgers = [];
    @observable outgoingLedgers = [];
    @observable incomingPage = 1;
    @observable outgoingPage = 1;
    @observable showMoreOutgoing = false;
    @observable showMoreIncoming = false;       
    @observable selectedOutgoingLedgers  = undefined
    @observable selectedIncomingLedgers  = undefined
    

    @observable statusFilter = undefined;
    @observable isGrouped = false;

    @observable filter = {
        contactName: undefined
    }
    @action
    resetFilter(){
        this.filter = {
            contactName: undefined
        }
        this.statusFilter = undefined;
        this.isGrouped = false;
    }

    @action
    setStatusFilter(value) {
        this.statusFilter = value;
    }

    @action
    setIsGrouped(value) {
        this.isGrouped = value;
    }

    @action
    setFilterAttr(key, value){
        this.filter[key] = value;
    }

    @action
    resetLedgerPage(){
        this.incomingPage = 1;
        this.outgoingPage = 1;
        this.outgoingLedgers= []
        this.incomingLedgers = []
        this.showMoreOutgoing = false
        this.showMoreIncoming = false

    }
    @action
    clearIncomingOutgoingInvoices = () => {
        this.incomingLedgers = [];
        this.outgoingLedgers = [];
    };
    @action
    setSelectedOutgoingLedgers(value){
        this.selectedOutgoingLedgers = value;
    }
    @action
    setSelectedIncomingLedgers(value){
        this.selectedIncomingLedgers = value;
    }

    @action
    outgoingMarksAsPaid(id,isPaid){
        this.outgoingLedgers.forEach((ledger) => {
            if(ledger.id === id){
                if(isPaid){
                    ledger.status = SuperLedgerStatus.Paid.ordinal
                }else{
                    ledger.status = SuperLedgerStatus.Pending.ordinal
                }
                
            }
        })

    }

     @action
    payLedger(id, data) {
        const currentProfile = profileStore.getCurrentProfile();
            this.inProgress = true;
            templateStore.showLoadingScreen();
    
            return agent.SuperLedgers.payLedger(currentProfile?.id, id, data)
                .then(
                    action(response => {
                        return response;
                    })
                )
                .finally(() => {
                    templateStore.hideLoadingScreen();
                    this.inProgress = false;
                });
        }

    @action
    unpayLedger(id) {
        const currentProfile = profileStore.getCurrentProfile();
        this.inProgress = true;
        templateStore.showLoadingScreen();

        return agent.SuperLedgers.unpayLedger(currentProfile?.id, id)
            .then(
                action(response => {
                    return response;
                })
            )
            .finally(() => {
                templateStore.hideLoadingScreen();
                this.inProgress = false;
            });
    }

        
    
    @action
    incomingMarksAsPaid(id, isPaid){
        this.incomingLedgers.forEach((ledger) => {
            if(ledger.id === id){
                 if(isPaid){
                    ledger.status = SuperLedgerStatus.Paid.ordinal
                }else{
                    ledger.status = SuperLedgerStatus.Pending.ordinal
                }
            }
        })

        // this.incomingInvoices = this.incomingInvoices
    }

    @action
    getLedgersByPayeeId(payeeId, page) {
        const { startDate, endDate, superLedgerId, venueId, organisationId, stateId, regionId } = reportStore;
        const startDateFormated = startDate ? moment(startDate).format("MM-DD-YYYY") : undefined;
        const endDateFormated = endDate ? moment(endDate).format("MM-DD-YYYY") : undefined;
        templateStore.showLoadingScreen();
        return agent.SuperLedgers.getLedgersByPayeeId(payeeId, 20, page, startDateFormated, endDateFormated, this.filter.contactName, venueId, superLedgerId, organisationId, stateId, regionId, this.statusFilter).then(
            action(result => {
                const ledgers = result.data || [];
                this.outgoingLedgers = this.outgoingLedgers.concat(ledgers);
                this.showMoreOutgoing = result.isMore;
                this.outgoingPage = page;
                return this.outgoingLedgers;
            })
        ).finally(() => {
            templateStore.hideLoadingScreen();
            this.inProgress = false;
        });
    }

    @action
    getLedgersByPayerId(payerId, page) {
        const { startDate, endDate, venueId, superLedgerId, organisationId, stateId, regionId } = reportStore;
        const startDateFormated = startDate ? moment(startDate).format("MM-DD-YYYY") : undefined;
        const endDateFormated = endDate ? moment(endDate).format("MM-DD-YYYY") : undefined;
        templateStore.showLoadingScreen();
        return agent.SuperLedgers.getLedgersByPayerId(payerId, 20, page, startDateFormated, endDateFormated, this.filter.contactName, venueId, superLedgerId, organisationId, stateId, regionId, this.statusFilter).then(
            action(result => {
                const ledgers = result.data || [];
                this.incomingLedgers = this.incomingLedgers.concat(ledgers);
                this.showMoreIncoming = result.isMore;
                this.incomingPage = page;
                return this.incomingLedgers;
            })
        ).finally(() => {
            templateStore.hideLoadingScreen();
        });
    }

    @action
    getGroupedLedgersByPayeeId(payeeId) {
        const { startDate, endDate, superLedgerId, venueId, organisationId, stateId, regionId } = reportStore;
        const startDateFormated = startDate ? moment(startDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        const endDateFormated = endDate ? moment(endDate).format("MM-DD-YYYY HH:mm:ss.SSS") : undefined;
        
        templateStore.showLoadingScreen();
        return agent.SuperLedgers.getLedgersGroupedByPayeeId(payeeId, startDateFormated, endDateFormated, this.filter.contactName, venueId, superLedgerId, organisationId, stateId, regionId, this.statusFilter).then(
            action(result => {
                var ledgers = result.data || [];
                this.outgoingLedgers = ledgers;
                this.showMoreOutgoing = false;
                return this.outgoingLedgers;
            })
        ).finally(() => {
            templateStore.hideLoadingScreen();
            this.inProgress = false;
        });
    }

    @action
    getGroupedLedgersByPayerId(payerId) {
        const { startDate, endDate, venueId, superLedgerId, organisationId, stateId, regionId } = reportStore;
        const startDateFormated = startDate ? moment(startDate).format("MM-DD-YYYY") : undefined;
        const endDateFormated = endDate ? moment(endDate).format("MM-DD-YYYY") : undefined;
        
        templateStore.showLoadingScreen();
        return agent.SuperLedgers.getLedgersGroupedByPayerId(payerId, startDateFormated, endDateFormated, this.filter.contactName, venueId, superLedgerId, organisationId, stateId, regionId, this.statusFilter).then(
            action(result => {
                var ledgers = result.data || [];
                this.incomingLedgers = ledgers;
                this.showMoreIncoming = false;
                return this.incomingLedgers;
            })
        ).finally(() => {
            templateStore.hideLoadingScreen();
        });
    }

    @action
    paySuperLedgersManually(data) {
        this.inProgress = true;
        templateStore.showLoadingScreen();

        return agent.SuperLedgers.paySuperLedgersManually(data)
            .then(
                action(response => {
                    return response;
                })
            )
            .finally(() => {
                templateStore.hideLoadingScreen();
                this.inProgress = false;
            });
    }

    @action
    validateSuperAnnuation(payeeIds) {
        return agent.HgSuperPay.validatePayees({ payeeIds })
            .then(
                action(response => {
                    const validatedPayees = response?.data || response?.response || [];
                    const validationMap = new Map();
                    
                    validatedPayees.forEach(item => {
                        validationMap.set(item.payeeId, {
                            isValidated: item.isValidated,
                            employeeId: item.employeeId || null,
                            validationReason: item.reason || null
                        });
                    });
                    
                    this.incomingLedgers = this.incomingLedgers.map(ledger => {
                        if (validationMap.has(ledger.payeeId)) {
                            const validation = validationMap.get(ledger.payeeId);
                            const updatedItems = ledger.items 
                                ? ledger.items.map(item => ({ 
                                    ...item, 
                                    isValidated: validation.isValidated, 
                                    employeeId: validation.employeeId,
                                    validationReason: validation.validationReason
                                }))
                                : undefined;
                            return { 
                                ...ledger, 
                                isValidated: validation.isValidated, 
                                employeeId: validation.employeeId,
                                validationReason: validation.validationReason,
                                items: updatedItems 
                            };
                        }
                        return ledger;
                    });
                    return { data: validatedPayees };
                })
            );
    }

    @action
    markLedgersAsPaidInStore(ledgerIds) {
        const ledgerIdSet = new Set(ledgerIds);

        const markList = (list) => {
            list.forEach(ledger => {
                if (ledger.items) {
                    ledger.items.forEach(item => {
                        if (ledgerIdSet.has(item.id)) {
                            item.status = SuperLedgerStatus.Paid.ordinal;
                        }
                    });
                } else if (ledgerIdSet.has(ledger.id)) {
                    ledger.status = SuperLedgerStatus.Paid.ordinal;
                }
            });
        };

        markList(this.outgoingLedgers);
        markList(this.incomingLedgers);
    }

    @action
    markLedgersAsProcessingInStore(ledgerIds) {
        const ledgerIdSet = new Set(ledgerIds);

        const markList = (list) => {
            list.forEach(ledger => {
                if (ledger.items) {
                    ledger.items.forEach(item => {
                        if (ledgerIdSet.has(item.id)) {
                            item.status = SuperLedgerStatus.Processing.ordinal;
                        }
                    });
                } else if (ledgerIdSet.has(ledger.id)) {
                    ledger.status = SuperLedgerStatus.Processing.ordinal;
                }
            });
        };

        markList(this.outgoingLedgers);
        markList(this.incomingLedgers);
    }
}

export default new SuperLedgerStore();
